import { combineReducers } from 'redux';

import roster from './roster/reducers';
import benchmark from './benchmark/reducers';
import progress from './progress/reducers';
import planning from './planning/reducers';
import parent from './parent/reducers';
import diagnostic from './diagnostic/reducers';
import tracking from './tracking/reducers';
import teacher from './teacher/reducers';
import dyslexia from './dyslexia/reducers';
import skillsstatus from './skillsstatus/reducers'
import readingrope from './readingrope/reducers'
import skillsdiagnostic from './skillsdiagnostic/reducers'
import assignment from './assignment/reducers'
import badging from './badging/reducers'
import classprogress from './classprogress/reducers'

const reports = combineReducers({
  roster,
  benchmark,
  progress,
  parent,
  planning,
  diagnostic,
  tracking,
  teacher,
  dyslexia,
  skillsstatus,
  readingrope,
  skillsdiagnostic,
  assignment,
  badging,
  classprogress,
})

export default reports